import React from "react";
import {useNavigate} from "react-router-dom";
import pispFigure from "/assets/pisp-figure.svg?url"
import HeaderItem from "../../components/headerItem/HeaderItem";
import FeatureKey from "../../components/featureKey/FeatureKey";
import {FeatureContainer, FeatureGrid, FeatureKeyTitle} from "../../components/featureKey/FeatureKey.css";
import StoreItem from "../../components/storeItem/StoreItem";
import cardLogo from "/assets/api-card-logo.svg?url"
import oauth2Logo from "/assets/api-oauth2-logo.svg?url"
import {Recommended, SeeAlsoText} from "../../global.css";
import ScrollToTop from "@hooks/scrollToTop";

function Pisp() {
    const navigate = useNavigate()
    return (
        <div>
            <HeaderItem title={"PISP"}
                        description={"L'API PISP (Payment Initiation Service Provider), permet à des tiers, tels que des fournisseurs de services de paiement ou des applications, d'initier des paiements en ligne au nom d'un utilisateur. Cette API est une composante clé de la Directive sur les services de paiement 2 (DSP2) de l'Union européenne, qui vise à ouvrir le marché des paiements en ligne, à améliorer la sécurité des transactions et à encourager l'innovation dans le secteur des services financiers."}
                        imageUrl={pispFigure}
                        onClick={() => navigate("/pisp/documentation")}>
            </HeaderItem>

            <div className={FeatureKeyTitle}>Fonctionnalités Clés</div>

            <div className={FeatureContainer}>
                <div className={FeatureGrid}>
                    <FeatureKey title={"1"} description1={"Initiation"} description2={"de paiement"}></FeatureKey>
                    <FeatureKey title={"2"} description1={"Confirmation"} description2={"de paiement"}></FeatureKey>
                </div>

                <div className={SeeAlsoText}>Nous vous recommandons aussi....</div>
                <div className={Recommended}>
                    <StoreItem
                        title={"AISP"}
                        description={"Prestataires de services d’information sur les comptes"}
                        onClick={() => navigate("/aisp")}
                        imageUrl={cardLogo}>
                    </StoreItem>
                    <StoreItem
                        title={"OAuth2"}
                        description={"Protocole d'autorisation à accès limité aux ressources utilisateur"}
                        onClick={() =>navigate("/oauth2")}
                        imageUrl={oauth2Logo}>
                    </StoreItem>
                </div>
            </div>
            <ScrollToTop />
        </div>
    );
}

export default Pisp;